<select [ngModel]="selectedValue" (ngModelChange)="onChange($event)"  [disabled]="!editable"> 
    <option *ngFor="let opt of options"  [ngValue]="opt.id">{{ opt.name }}</option> 
  </select> 